import {useState, useCallback, useEffect} from "react";
import {Redirect} from "react-router-dom";

import {useAuth} from "../../hooks/useAuthProvide";
import {SITES_ROUTE} from "../../lib/routes";
import { ContainerCustom4 } from "../../Theme/ContainerStyle";
import LoginForm from "./LoginForm";

export default function Login() {

  const [username, setUsername] = useState(localStorage.getItem("CloudControl_username") || "");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    username: false,
    password: false,
  });
  const [loginError, setLoginError] = useState(null);
  const {user, sessionExpired, returnsTo, login} = useAuth();

  ////USEEFFECT PER MEMORIZZARE O CANCELLARE L'USER DAL LOCALSTORAGE
  useEffect(() => {
    if (rememberMe) {
      localStorage.setItem("CloudControl_username", username);
    } else {
      localStorage.removeItem("CloudControl_username");
    }
  }, [rememberMe, username]);
  ////
  const onChangeUsername = useCallback(event => setUsername(event.target.value), []);
  const onChangePassword = useCallback(event => setPassword(event.target.value), []);
  const onToggleShowPassword = useCallback(() => setShowPassword(!showPassword), [showPassword]);
  const onMouseDownPassword = useCallback(event => event.preventDefault(), []);
  const onChangeRememberMe = useCallback(() => setRememberMe(!rememberMe), [rememberMe]);

  const onSubmit = useCallback(async event => {
    event.preventDefault();

    const usernameIsInvalid = username.trim() === "";
    const passwordIsInvalid = password.trim() === "";

    setValidationErrors({
      username: usernameIsInvalid,
      password: passwordIsInvalid,
    });

    setLoginError(null);

    if (usernameIsInvalid || passwordIsInvalid) {
      return;
    }

    setIsLoading(true);

    try {
      await login({username, password});
    } catch (error) {
      setIsLoading(false);
      setLoginError(error.message);
      console.log(error);
    }
  }, [username, password, login]);

  if (user) {
    console.log("Logged in returnsTo", returnsTo);
    return (
      <Redirect to={returnsTo || SITES_ROUTE.path} />
    );
  }

  const usernameHasError = validationErrors.username;
  const passwordHasError = validationErrors.password;

  const propsLog = {
    username, 
    password,
    showPassword,  
    rememberMe,    
    loginError,
    sessionExpired,
    isLoading,
    usernameHasError,
    passwordHasError,
    ...{onSubmit,
        onChangeUsername,
        onChangePassword,
        onChangeRememberMe,
        onToggleShowPassword,
        onMouseDownPassword,
    }
  }

  return (
    <ContainerCustom4>
      <LoginForm {...propsLog}/>
    </ContainerCustom4>
  );
}
